/* global gsap */
// import $ from 'jquery' // jQuery

// import "./module/_hashScroll"; // アンカーリンクスクロール
// import "./module/_spMenuToggle"; // SPメニュー開閉

/* ==========================================
SP ハンバーガーメニュー
========================================== */
document.addEventListener("DOMContentLoaded", () => {
  const btn     = document.getElementById("gNav-open");
  const nav     = document.getElementById("gNav");
  const overlay = document.getElementById("gNavOverlay");
  const header  = document.getElementById("header");
  const btnText = btn?.querySelector(".gNavBtn__text");
  if (!btn || !nav) return;

  const syncNavTop = () => {
    if (!header) return;
    const headerBottom = header.getBoundingClientRect().bottom;
    const logoEl = document.querySelector(".headerLogo");
    const logoBottom = logoEl ? logoEl.getBoundingClientRect().bottom : 0;
    const h = Math.max(headerBottom, logoBottom);
    document.documentElement.style.setProperty("--gNav-top", h + "px");
  };

  const open = () => {
    syncNavTop();
    btn.classList.add("is-open");
    nav.classList.add("is-open");
    overlay?.classList.add("is-open");
    btn.setAttribute("aria-label", "メニューを閉じる");
    nav.setAttribute("aria-hidden", "false");
    if (btnText) btnText.textContent = "閉じる";
    document.body.style.overflow = "hidden";
  };

  const close = () => {
    btn.classList.remove("is-open");
    nav.classList.remove("is-open");
    overlay?.classList.remove("is-open");
    btn.setAttribute("aria-label", "メニューを開く");
    nav.setAttribute("aria-hidden", "true");
    if (btnText) btnText.textContent = "メニュー";
    document.body.style.overflow = "";
  };

  window.addEventListener("resize", () => {
    if (btn.classList.contains("is-open")) syncNavTop();
  });

  btn.addEventListener("click", () => {
    btn.classList.contains("is-open") ? close() : open();
  });

  overlay?.addEventListener("click", close);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && btn.classList.contains("is-open")) close();
  });

  // アコーディオン（GSAP アニメーション）
  nav.querySelectorAll(".gNav__label--acc, .gNav__labelToggle").forEach((accBtn) => {
    const sub = accBtn.closest(".gNav__item").querySelector(".gNav__sub, .gNav__diseases, .gNav__faq");
    if (!sub) return;
    // hidden 属性を外し、GSAP で高さ 0 の初期状態を設定
    sub.removeAttribute("hidden");
    gsap.set(sub, { height: 0, overflow: "hidden" });

    accBtn.addEventListener("click", () => {
      const expanded = accBtn.getAttribute("aria-expanded") === "true";
      accBtn.setAttribute("aria-expanded", String(!expanded));

      if (expanded) {
        gsap.to(sub, { height: 0, duration: 0.3, ease: "power2.in" });
      } else {
        gsap.to(sub, { height: "auto", duration: 0.4, ease: "power2.out" });
      }
    });
  });
});

/* ==========================================
SP フッターナビ アコーディオン
========================================== */
document.addEventListener("DOMContentLoaded", () => {
  const spMatch = window.matchMedia("(max-width: 768px)");
  let wasSp = null;
  const items = Array.from(document.querySelectorAll(".footerNav"))
    .map((item, index) => {
      const toggleBtn = item.querySelector(".footerNav__toggle");
      const mainLink = item.querySelector(".footerNav__link--main");
      const trigger = toggleBtn || mainLink;
      const panel = item.querySelector(".footerNavList");
      if (!trigger || !panel) return null;

      const label = mainLink ? mainLink.textContent.replace(/\s+/g, "") : trigger.textContent.replace(/\s+/g, "");
      const id = panel.id || `footerNavList-${index + 1}`;
      panel.id = id;
      item.classList.add("footerNav--acc");
      trigger.setAttribute("aria-controls", id);
      trigger.setAttribute("aria-expanded", "false");

      return { trigger, panel, label };
    })
    .filter(Boolean);

  if (!items.length) return;

  const sync = () => {
    const isSp = spMatch.matches;
    items.forEach(({ trigger, panel, label }) => {
      gsap.killTweensOf(panel);

      if (isSp) {
        if (wasSp === false) {
          trigger.setAttribute("aria-expanded", "false");
        }
        const expanded = trigger.getAttribute("aria-expanded") === "true";
        if (trigger.tagName === "A") trigger.setAttribute("role", "button");
        trigger.setAttribute(
          "aria-label",
          `${label}の下層メニューを${expanded ? "閉じる" : "開く"}`,
        );
        gsap.set(panel, {
          height: expanded ? "auto" : 0,
          overflow: "hidden",
        });
      } else {
        trigger.removeAttribute("role");
        trigger.removeAttribute("aria-label");
        trigger.setAttribute("aria-expanded", "true");
        gsap.set(panel, { clearProps: "height,overflow" });
      }
    });
    wasSp = isSp;
  };

  items.forEach(({ trigger, panel, label }) => {
    trigger.addEventListener("click", (e) => {
      if (!spMatch.matches) return;

      if (trigger.tagName === "A") e.preventDefault();
      const expanded = trigger.getAttribute("aria-expanded") === "true";
      trigger.setAttribute("aria-expanded", String(!expanded));
      trigger.setAttribute(
        "aria-label",
        `${label}の下層メニューを${expanded ? "開く" : "閉じる"}`,
      );

      if (expanded) {
        gsap.to(panel, { height: 0, duration: 0.3, ease: "power2.in" });
      } else {
        gsap.to(panel, { height: "auto", duration: 0.4, ease: "power2.out" });
      }
    });
  });

  sync();
  if (spMatch.addEventListener) {
    spMatch.addEventListener("change", sync);
  } else {
    spMatch.addListener(sync);
  }
});

/* ==========================================
SP トップMVコピー可変フィット
========================================== */
document.addEventListener("DOMContentLoaded", () => {
  const title = document.querySelector(".topMvTitle");
  if (!title) return;

  const small = title.querySelector(".topMvTitle__small");
  const main = Array.from(title.children).find(
    (el) => !el.classList.contains("topMvTitle__small"),
  );
  const big = title.querySelector(".topMvTitle__big");
  const medium = title.querySelector(".topMvTitle__medium");
  if (!small || !main || !big || !medium) return;

  const spMatch = window.matchMedia("(max-width: 768px)");
  const mediumRatio = 0.806;
  const cssVars = [
    "--top-mv-small-font-size",
    "--top-mv-big-font-size",
    "--top-mv-medium-font-size",
  ];
  let rafId = 0;

  const reset = () => {
    cssVars.forEach((name) => title.style.removeProperty(name));
  };

  const fitFontSize = (apply, measure, target, min, max) => {
    let low = min;
    let high = max;

    for (let i = 0; i < 16; i++) {
      const mid = (low + high) / 2;
      apply(mid);

      if (measure() <= target) {
        low = mid;
      } else {
        high = mid;
      }
    }

    apply(Math.max(min, low - 0.1));
  };

  const fit = () => {
    if (!spMatch.matches) {
      reset();
      return;
    }

    const target = title.clientWidth;
    if (!target) return;

    fitFontSize(
      (size) => {
        title.style.setProperty("--top-mv-small-font-size", `${size}px`);
      },
      () => small.scrollWidth,
      target,
      10,
      Math.max(28, target / 8),
    );

    fitFontSize(
      (size) => {
        title.style.setProperty("--top-mv-big-font-size", `${size}px`);
        title.style.setProperty(
          "--top-mv-medium-font-size",
          `${size * mediumRatio}px`,
        );
      },
      () => main.scrollWidth,
      target,
      18,
      Math.max(42, target / 4),
    );
  };

  const scheduleFit = () => {
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(fit);
  };

  scheduleFit();
  window.addEventListener("resize", scheduleFit);

  if (spMatch.addEventListener) {
    spMatch.addEventListener("change", scheduleFit);
  } else {
    spMatch.addListener(scheduleFit);
  }

  if (document.fonts?.ready) {
    document.fonts.ready.then(scheduleFit);
  }
});

/* global */ // tUrl等のグローバル変数を宣言する

// import './_top.js'
// import './_form.js'

// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

document.addEventListener("DOMContentLoaded", () => {
  const mvSwiperCycle = 5000;
  const mvSwiperSpeed = 1500;
  let mvSwiperTimer = null;
  const mvSwiper = new Swiper(".topMv.swiper", {
    loop: true,
    effect: "fade",
    speed: mvSwiperSpeed,
    pagination: {
      el: ".topMv__pagination",
      clickable: true,
    },
  });

  const mvPagination = document.querySelector(".topMv__pagination");

  const startMvProgress = () => {
    if (!mvPagination) return;
    mvPagination.classList.remove("is-mv-progressing");
    void mvPagination.offsetWidth;
    mvPagination.classList.add("is-mv-progressing");
  };

  // reveal: スライド切り替え時のみマスク演出付き。初回1枚目(LCP対象)はズームのみ
  const startMvZoom = (slide, reveal) => {
    if (!slide) return;
    slide.classList.remove("is-mv-zooming", "is-mv-zoomed", "is-mv-revealing");
    void slide.offsetWidth;
    slide.classList.add(reveal ? "is-mv-revealing" : "is-mv-zooming");
  };

  const startMvCycle = (reveal) => {
    clearTimeout(mvSwiperTimer);

    const activeSlide = mvSwiper.slides[mvSwiper.activeIndex];
    startMvZoom(activeSlide, reveal);
    startMvProgress();

    mvSwiperTimer = setTimeout(() => {
      activeSlide?.classList.remove("is-mv-zooming", "is-mv-revealing");
      activeSlide?.classList.add("is-mv-zoomed");
      mvPagination?.classList.remove("is-mv-progressing");
      mvSwiper.slideNext(mvSwiperSpeed);
    }, mvSwiperCycle);
  };

  mvSwiper.on("slideChangeTransitionStart", () => startMvCycle(true));

  mvSwiper.on("slideChangeTransitionEnd", () => {
    mvSwiper.slides.forEach((slide) => {
      if (slide !== mvSwiper.slides[mvSwiper.activeIndex]) {
        slide.classList.remove("is-mv-zooming", "is-mv-zoomed", "is-mv-revealing");
      }
    });
  });

  startMvCycle(false);
});

// ==========================================================================
// 汎用カードスライダー (.cardSlider)
// PC: 3枚を静的表示 / SP: Slickでセンター表示＋両サイドチラ見え
// ==========================================================================
window.addEventListener("load", () => {
  const $ = window.jQuery;
  if (!$ || typeof $.fn.slick !== "function") return;

  const CARD_SLIDER_AUTO_CYCLE = 5000;
  const sliders = document.querySelectorAll(".cardSlider");
  const sliderTimers = new WeakMap();

  const syncActiveDot = (paginationEl) => {
    if (!paginationEl) return;

    paginationEl
      .querySelectorAll(".cardSlider__bullet")
      .forEach((bullet) =>
        bullet.classList.toggle(
          "cardSlider__bullet--active",
          Boolean(bullet.closest(".slick-active")),
        ),
      );
  };

  const restartSliderProgress = (paginationEl) => {
    if (!paginationEl) return;
    paginationEl.classList.remove(
      "is-feature-progressing",
      "is-card-slider-progressing",
    );
    void paginationEl.offsetWidth;
    paginationEl.classList.add(
      "is-feature-progressing",
      "is-card-slider-progressing",
    );
  };

  const stopSliderCycle = (trackEl) => {
    const timer = sliderTimers.get(trackEl);
    if (timer) clearTimeout(timer);
    sliderTimers.delete(trackEl);
  };

  const startSliderCycle = (trackEl, paginationEl, $track) => {
    stopSliderCycle(trackEl);
    restartSliderProgress(paginationEl);

    sliderTimers.set(
      trackEl,
      window.setTimeout(() => {
        if ($track.hasClass("slick-initialized")) {
          $track.slick("slickNext");
        }
      }, CARD_SLIDER_AUTO_CYCLE),
    );
  };

  const initSlider = (sliderEl) => {
    const trackEl = sliderEl.querySelector(".js-card-slick");
    const paginationEl = sliderEl.querySelector(".cardSlider__pagination");
    const prevEl = sliderEl.querySelector(".cardSlider__prev");
    const nextEl = sliderEl.querySelector(".cardSlider__next");
    if (!trackEl || !paginationEl || !prevEl || !nextEl) return;

    const $track = $(trackEl);
    if ($track.hasClass("slick-initialized")) return;

    const hasAutoProgress =
      sliderEl.classList.contains("topFeature__slider") ||
      sliderEl.classList.contains("cardSlider--auto");
      
    const updateUi = () => {
      syncActiveDot(paginationEl);
      if (hasAutoProgress) {
        startSliderCycle(trackEl, paginationEl, $track);
      }
    };

    $track
      .off(".cardSlider")
      .on("beforeChange.cardSlider", () => {
        if (hasAutoProgress) stopSliderCycle(trackEl);
      })
      .on("init.cardSlider reInit.cardSlider", (event, slick) => {
        // SEO対策: クローンされた h3 タグを div タグに置換する
        $(trackEl).find('.slick-cloned h3.topFeatureItem__title').each(function() {
          const $heading = $(this);
          const $div = $('<div>')
            .addClass($heading.attr('class'))
            .html($heading.html());
          $heading.replaceWith($div);
        });
        updateUi();
      })
      .on("afterChange.cardSlider", updateUi)
      .slick({
        arrows: true,
        dots: true,
        infinite: true,
        // ▼ PC表示の設定 (ベース) ▼
        slidesToShow: 3, // PCでは3枚表示
        slidesToScroll: 1,
        // centerMode はスマホ専用にするためベースからは削除
        speed: 500,
        cssEase: "ease",
        swipeToSlide: true,
        touchThreshold: 10,
        waitForAnimate: false,
        autoplay: false,
        appendDots: $(paginationEl),
        prevArrow: $(prevEl),
        nextArrow: $(nextEl),
        dotsClass: "cardSlider__dots",
        customPaging: (_slick, index) =>
          `<button type="button" class="cardSlider__bullet" aria-label="${
            index + 1
          }枚目を表示"><svg class="cardSlider__ring" viewBox="0 0 36 36" aria-hidden="true"><circle class="cardSlider__ringProgress" cx="18" cy="18" r="16" pathLength="100"></circle></svg></button>`,
        // ▼ スマホ表示の設定 (768px以下) ▼
        responsive: [
          {
            breakpoint: 769, 
            settings: {
              slidesToShow: 1,       // 1枚表示
              centerMode: true,      // 左右を少し見せる
              centerPadding: "34px",
            }
          }
        ]
      });
  };

  // ページ上のすべてのスライダーを初期化
  sliders.forEach((sliderEl) => {
    initSlider(sliderEl);
  });
});

// ==========================================================================
// 2. スクロール時のヘッダー表示切り替え制御
// ==========================================================================
document.addEventListener("DOMContentLoaded", () => {
  const scrollThreshold = 120;
  const checkScroll = () => {
    if (window.scrollY > scrollThreshold) {
      document.body.classList.add("is-scrolled");
    } else {
      document.body.classList.remove("is-scrolled");
    }
  };
  window.addEventListener("scroll", checkScroll, { passive: true });
  checkScroll();
});

// ==========================================================================
// 3. メガメニュー ホバー制御（縦・横デッドゾーン対策 + オーバーレイ）
// ==========================================================================
document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("headerMegaOverlay");
  const header = document.getElementById("header");
  // デッドゾーン通過の猶予時間（縦：ヘッド↔パネル間、横：アイテム間）
  const HIDE_DELAY = 150;

  // メガメニューを持つ全pulldownを先に収集
  const items = [];
  document.querySelectorAll(".headerPulldown").forEach((pd) => {
    const body = pd.querySelector(".headerPulldown__body");
    if (!body) return;
    items.push({ pd, body, timer: null });
  });

  items.forEach((item) => {
    const openThis = () => {
      // 他のタイマーを全キャンセルし即閉じ → 横移動でちらつかない
      items.forEach((other) => {
        clearTimeout(other.timer);
        if (other !== item) other.pd.classList.remove("is-open");
      });
      item.pd.classList.add("is-open");
      if (header) header.classList.add("is-mega-open");
      if (overlay) overlay.classList.add("active");
    };

    const closeThis = () => {
      item.timer = setTimeout(() => {
        item.pd.classList.remove("is-open");
        // 他にも開いているものがなければオーバーレイも消す
        if (!document.querySelector(".headerPulldown.is-open")) {
          if (header) header.classList.remove("is-mega-open");
          if (overlay) overlay.classList.remove("active");
        }
      }, HIDE_DELAY);
    };

    item.pd.addEventListener("mouseenter", openThis);
    item.pd.addEventListener("mouseleave", closeThis);
    item.body.addEventListener("mouseenter", openThis);
    item.body.addEventListener("mouseleave", closeThis);
  });
});

// ==========================================================================
// 5. 症状・病気 詳細ページ：目次の自動生成
// ==========================================================================
document.addEventListener("DOMContentLoaded", () => {
  const content = document.getElementById("diseasesSingleContent");
  const tocList = document.getElementById("diseasesTocList");
  if (!content || !tocList) return;

  const headings = content.querySelectorAll("h2");
  if (headings.length === 0) {
    document.getElementById("diseasesToc")?.remove();
    return;
  }

  tocList.replaceChildren();

  headings.forEach((heading, i) => {
    const id = `toc-section-${i + 1}`;
    heading.id = id;

    const li = document.createElement("li");
    li.className = "diseasesToc__item";

    const a = document.createElement("a");
    a.href = `#${id}`;

    const dash = document.createElement("span");
    dash.className = "diseasesToc__dash";
    dash.textContent = "–";

    const text = document.createElement("span");
    text.className = "diseasesToc__text";
    text.textContent = heading.textContent;

    const chevron = document.createElement("span");
    chevron.className = "diseasesToc__chevronIcon";
    chevron.setAttribute("aria-hidden", "true");

    a.appendChild(dash);
    a.appendChild(text);
    a.appendChild(chevron);
    li.appendChild(a);
    tocList.appendChild(li);
  });
});

// ==========================================================================
// 6. スムーススクロール
// ==========================================================================
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();
    const targetId = this.getAttribute("href");
    if (targetId === "#") return;

    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      // 飛び先要素に scroll-margin-top が指定されていればそれをオフセットに使う
      // （CSS側で追従サイドバー等と位置を揃えられるようにする）。未指定なら既定値。
      const scrollMargin = parseFloat(
        window.getComputedStyle(targetElement).scrollMarginTop
      );
      const headerHeight = scrollMargin || 115;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({ top: offsetPosition, behavior: "smooth" });

      const cleanUrl = window.location.pathname + window.location.search;
      window.history.replaceState(null, "", cleanUrl);
    }
  });
});

// ==========================================================================
// 7. 蛍光マーカーアニメーション (.gastroFeatureCard__title span, .gastroSedationCard__title span)
// ==========================================================================
document.addEventListener("DOMContentLoaded", () => {
  const spans = document.querySelectorAll(".gastroFeatureCard__title span, .gastroSedationCard__title span");
  if (!spans.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-highlighted");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.8 }
  );

  spans.forEach((span) => observer.observe(span));
});

// ==========================================================================
// 8. ページトップボタン：スクロール量に連動した円形プログレス
// ==========================================================================
document.addEventListener("DOMContentLoaded", () => {
  const pageTop = document.querySelector("[data-page-top]");
  if (!pageTop) return;

  const showThreshold = 240;
  let ticking = false;

  const getScrollProgress = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
    const scrollMax = Math.max(
      document.documentElement.scrollHeight - window.innerHeight,
      1
    );

    return Math.min(Math.max((scrollTop / scrollMax) * 100, 0), 100);
  };

  const updatePageTop = () => {
    const progress = getScrollProgress();

    pageTop.style.setProperty("--page-top-progress", progress.toFixed(2));
    pageTop.classList.toggle("is-visible", window.scrollY > showThreshold);
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updatePageTop);
  };

  pageTop.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate);
  window.addEventListener("load", requestUpdate);
  updatePageTop();
});

// ==========================================================================
// 10. PC追従CTA：一定量スクロールで下→上スライドイン表示
// ==========================================================================
document.addEventListener("DOMContentLoaded", () => {
  const floatCta = document.querySelector("[data-pc-float-cta]");
  if (!floatCta) return;

  const showThreshold = 400;
  let ticking = false;

  const updateFloatCta = () => {
    floatCta.classList.toggle("is-visible", window.scrollY > showThreshold);
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateFloatCta);
  };

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate);
  window.addEventListener("load", requestUpdate);
  updateFloatCta();
});

// ==========================================================================
// 11. FAQ アコーディオン（GSAP で滑らかに開閉）
//   native <details> は no-JS フォールバックとして残し、
//   JS 有効時は click を奪って height 0 ↔ auto をアニメーション。
// ==========================================================================
document.addEventListener("DOMContentLoaded", () => {
  const details = Array.from(document.querySelectorAll(".faqItem__details"));
  if (!details.length || typeof gsap === "undefined") return;

  details.forEach((detail) => {
    const summary = detail.querySelector(".faqItem__ques");
    const panel = detail.querySelector(".faqItem__ans");
    if (!summary || !panel) return;

    // クリック範囲を faqItem 全体に拡張（質問行＋カード余白のどこでも開閉）
    const clickArea = detail.closest(".faqItem") || detail;

    let animating = false;

    clickArea.addEventListener("click", (e) => {
      // 回答エリア内（リンク等）のクリックは開閉に反応させない
      if (panel.contains(e.target)) return;

      e.preventDefault();
      if (animating) return;
      animating = true;

      if (detail.open) {
        // 閉じる：先に is-closing でアイコンを即時に戻し、高さを 0 へ
        detail.classList.add("is-closing");
        gsap.to(panel, {
          height: 0,
          duration: 0.3,
          ease: "power2.in",
          onComplete: () => {
            detail.open = false;
            detail.classList.remove("is-closing");
            gsap.set(panel, { clearProps: "height,overflow" });
            animating = false;
          },
        });
      } else {
        // 開く：open を立てて中身を描画 → 高さ 0 から auto へ
        detail.open = true;
        gsap.set(panel, { height: 0, overflow: "hidden" });
        gsap.to(panel, {
          height: "auto",
          duration: 0.4,
          ease: "power2.out",
          onComplete: () => {
            gsap.set(panel, { clearProps: "height,overflow" });
            animating = false;
          },
        });
      }
    });
  });
});

// ==========================================================================
// 12. アクセスページ：出発駅タブ切り替え
// ==========================================================================
document.addEventListener("DOMContentLoaded", () => {
  const tabs = Array.from(document.querySelectorAll("[data-access-tab]"));
  const panels = Array.from(document.querySelectorAll("[data-access-panel]"));
  if (!tabs.length || !panels.length) return;

  const activate = (key) => {
    tabs.forEach((tab) => {
      const isActive = tab.dataset.accessTab === key;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });
    panels.forEach((panel) => {
      const isActive = panel.dataset.accessPanel === key;
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => activate(tab.dataset.accessTab));
  });
});

// ==========================================================================
// 13. テキストせり上げ表示 (.revealUp)
//     overflow:hidden のマスク内で .revealUp__inner を下から上へスライドさせる。
//     付与方法は src/scss/_preset/_anime.scss の styleguide を参照。
// ==========================================================================
document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".revealUp");
  if (!targets.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-inview");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );

  targets.forEach((target) => {
    // 内側ラッパー(.revealUp__inner)が無ければ自動生成。
    // → マークアップ側は .revealUp を付けるだけでよい
    if (!target.querySelector(":scope > .revealUp__inner")) {
      const inner = document.createElement("span");
      inner.className = "revealUp__inner";
      while (target.firstChild) inner.appendChild(target.firstChild);
      target.appendChild(inner);
    }
    // ラップ完了の合図。これがCSSのチラ見え防止ガードを解除する
    target.classList.add("is-ready");
    observer.observe(target);
  });
});

// ==========================================================================
// 14. 目次／サイドバーのスクロールスパイ（FAQサイド・症状病気ページ目次 共通）
//     各リンクの href(#id) と一致する飛び先要素を現在地判定の対象にし、
//     閲覧中の項目に .is-current を付与する。判定ラインには飛び先の
//     scroll-margin-top を使い、スムーススクロールの着地位置と揃える。
// ==========================================================================
function initTocScrollSpy(linkSelector) {
  const links = document.querySelectorAll(linkSelector);
  if (!links.length) return;

  // 各リンクと、その href が指す飛び先要素を対にする
  const entries = [];
  links.forEach((link) => {
    const id = (link.getAttribute("href") || "").replace(/^#/, "");
    if (!id) return;
    const section = document.getElementById(id);
    if (!section) return;
    entries.push({ link, section });
  });
  if (!entries.length) return;

  const setCurrent = (current) => {
    entries.forEach(({ link }) => {
      link.classList.toggle("is-current", link === current);
    });
  };

  const offset =
    parseFloat(window.getComputedStyle(entries[0].section).scrollMarginTop) ||
    150;

  let ticking = false;
  const update = () => {
    ticking = false;
    // 判定ラインを上端が越えた飛び先のうち、最後（最も下）を現在地とする
    let current = entries[0].link;
    entries.forEach(({ link, section }) => {
      if (section.getBoundingClientRect().top - offset <= 1) {
        current = link;
      }
    });
    setCurrent(current);
  };

  window.addEventListener(
    "scroll",
    () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    },
    { passive: true }
  );
  window.addEventListener("resize", update);
  update();
}

document.addEventListener("DOMContentLoaded", () => {
  initTocScrollSpy(".faqSide__link");
});
